import script from "./setting.vue?vue&type=script&setup=true&lang=ts"
export * from "./setting.vue?vue&type=script&setup=true&lang=ts"

import "./setting.vue?vue&type=style&index=0&id=6c15c559&scoped=true&lang=less"

import exportComponent from "/Users/n0ts/Projects/IceCreamSearch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c15c559"]])

export default __exports__